/** Templates excluded from public gallery and pre-signup selection (admin management unchanged). */
export const HIDDEN_PUBLIC_TEMPLATE_IDS = new Set([
  '1758954190786-royal-ocean-v1__3_',
]);

export function isHiddenFromPublicGallery(template: {
  id?: string;
  name?: string;
  componentKey?: string;
} | null | undefined): boolean {
  if (!template) return false;
  const id = String(template.id || '').trim();
  if (id && HIDDEN_PUBLIC_TEMPLATE_IDS.has(id)) return true;
  const name = String(template.name || '').toLowerCase();
  if (name.includes('royal ocean')) return true;
  const key = String(template.componentKey || '').toLowerCase();
  if (key.includes('royal-ocean') || key.includes('royal_ocean')) return true;
  return false;
}

export function filterPublicGalleryTemplates<T extends { id?: string; name?: string; componentKey?: string }>(
  templates: T[]
): T[] {
  return templates.filter((t) => !isHiddenFromPublicGallery(t));
}
